/* global angular, $ */
angular.module('ua5App')
    .directive('resourceJumpable', ['$state', '$document', '$sce', '$rootScope', '$timeout', function($state, $document, $sce, $rootScope, $timeout) {
        return {
            restrict: 'A',
            templateUrl: 'components/resource-jumpable/resource-jumpable.html',
            scope: {
                content: '=',
                contentTitle: '@',
                sectionIndex: '@',
                columns: '@'
            },
            link: function($scope, element, attrs) {
                $scope.sortByRank = function(item) {
                    return parseInt(item.rank, 10);
                };

                $scope.jumpToSection = function(section) {
                    var headerHeight = $('#resources__header-nav').outerHeight() + 85;   // the scrolling header might be higher if words are stacked
                    var sectionOffset = $('#' + section).offset().top - headerHeight - 20;    // 20 for padding
                    $document.scrollTop(sectionOffset, 500);
                };

                $timeout(function() {
                    $rootScope.$broadcast('resourceComponentPosition', {sectionIndex: $scope.sectionIndex});
                });
            }
        };
    }])
;
